import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "joy-stick-container" }
const _hoisted_2 = { class: "joy-stick-inner" }
const _hoisted_3 = { class: "joy-stick-content" }

import { ref, reactive, toRefs, onMounted, onBeforeMount, onUnmounted,  watch } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isRemoteConnected : { // 是否连接遥控器
        type: Boolean,
        default: () => false,
    },
    isReady : { // 是否准备好
        type: Boolean,
        default: () => false,
    },
    promptMessage : { // 提示文本
        type: String,
        default: '未连接遥控器，为达到训练效果请使用遥控器飞行。',
    },
},
  setup(__props) {

const props = __props



// 是否显示提示
const showPrompt = ref(false)
// 解锁时间
const unlockTime = ref(null);

const timer = ref(null)

watch(() => props.isRemoteConnected, (val) => {
    if(props.isReady){
        switchConnect(val)
    }
}, {immediate: true,deep: true,})

watch(() => props.isReady, (val) => {
    if(val){
        if(!props.isRemoteConnected){
            unlockTime.value = new Date()
        }
        // switchConnect(props.isRemoteConnected)
    }
}, {immediate: true,deep: true,})

const switchConnect = (val:boolean) =>{ 
    if(val){
        //遥控器连接
        showPrompt.value = false
        unlockTime.value = null
    }else{
        //遥控器断开
        showPrompt.value = true
    }
}

const handleClose = () => {
    unlockTime.value = new Date()
    showPrompt.value = false;
}

onMounted(() => { 
    timer.value = setInterval(()=>{
        if(unlockTime.value){
            if(new Date().getTime() - unlockTime.value.getTime() >= 1000 * 60 * 5){
                unlockTime.value = null
                showPrompt.value = true;
            }
        }
    },1000)
})

onUnmounted(() => {
    clearInterval(timer.value)
})



return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(props.promptMessage), 1),
        _createVNode(_component_vkm_svg, {
          "icon-name": "closeIcon",
          class: "icon",
          onClick: handleClose
        })
      ])
    ])
  ], 512)), [
    [_vShow, showPrompt.value]
  ])
}
}

})